module.exports = __webpack_public_path__ + "static/media/cash-withdrawal.6c5779b5.svg";